import { Injectable } from '@angular/core';
import {CrudBaseService} from "./crud-base.service";
import {AtestadoModel} from "../models/atestado.model";
import {HttpClient} from "@angular/common/http";
import {IPrimaryKey} from "../interfaces/iprimary-key";

@Injectable({
  providedIn: 'root'
})
export class AtestadoService extends CrudBaseService<AtestadoModel> {

  constructor(http: HttpClient) {
    super(http, 'atestados');
  }

  public getPk(id: IPrimaryKey<AtestadoModel>): IPrimaryKey<AtestadoModel> {
    return Object.assign(new AtestadoModel(), id);
  }

  public getAllByNumeroGuia(numeroGuia: number) {
    return this.getAllByUrlQuery<AtestadoModel>(`numeroGuia/${numeroGuia}`);
  }

  public obterTiposAtestado(): string[] {
    return ['A1', 'A3', 'A4', 'A5', 'A6'];
  }

  public obterDescricaoAtestadoPorTipo(tipo: string | undefined): string {
    switch(tipo) {
      case 'A1':
        return 'Atestado Para Licença';
      case 'A3':
        return 'Atestado de Aptidão Física';
      case 'A4':
        return 'Declaração de Presença';
      case 'A5':
        return 'Declaração de Acompanhante';
      case 'A6':
        return 'Atestado de Saúde';
      default:
        return '';
    }
  }

  public obterTituloAtestadoPorTipo(tipo: string | undefined): string {
    switch(tipo) {
      case 'A1':
        return 'Atestado Para Licença';
      case 'A3':
        return 'ATESTADO';
      case 'A4':
        return 'DECLARAÇÃO DE COMPARECIMENTO';
      case 'A5':
        return 'DECLARAÇÃO DE ACOMPANHANTE';
      case 'A6':
        return 'Atestado de Saúde';
      default:
        return '';
    }
  }
}
